<template>
  <div class="file-input">
    <div v-if="item.value" class="file-input__value">
      <SvgIcon icon="file" class="file-input__value-icon" />
      <span class="file-input__value-name">{{ item.value.name }}</span>
      <SvgIcon icon="close" class="file-input__value-icon delete" @click="deleteFile" />
    </div>
    <div v-else class="file-input__add">
      <label :for="field" class="file-input__add-button" :class="[{ isError: errorText }]" type="button" @click="openFile">
        <span class="file-input__add-button-text">{{ item.text }}</span>
        <SvgIcon icon="plus" class="file-input__add-button-icon" />
      </label>
      <input :id="field" ref="fileInput" :accept="acceptType" type="file" hidden @change="handleFileChange">
    </div>
    <span
      v-if="errorText"
      class="file-input__error"
    >
      {{ errorText }}
    </span>
  </div>
</template>

<script lang="ts" src="./FileInput.ts"></script>

<style lang="scss" scoped src="./FileInput.scss"></style>
